$.fn.select2.amd.define('select2/data/extended-ajax',['./ajax','./tags','../utils','module','jquery'], function(AjaxAdapter, Tags, Utils, module, $){
  return ExtendedAjaxAdapterDefiner(AjaxAdapter, Tags, Utils, module, $)
})

$.fn.select2.amd.define('select2/data/extended-ajax-tags',['./ajax','./tags','../utils','module','jquery'], function(AjaxAdapter, Tags, Utils, module, $){
  return ExtendedAjaxAdapterDefiner(AjaxAdapter, Tags, Utils, module, $, true)
})

function ExtendedAjaxAdapterDefiner(AjaxAdapter, Tags, Utils, module, $, withTags=false) {
  function ExtendedAjaxAdapter ($element,options) {
    //we need explicitly process minimumInputLength value
    //to decide should we use AjaxAdapter or return defaultResults,
    //so it is impossible to use MinimumLength decorator here
    this.minimumInputLength = options.get('minimumInputLength');
    this.defaultResults     = options.get('defaultResults');

    ExtendedAjaxAdapter.__super__.constructor.call(this,$element,options);
  }

  Utils.Extend(ExtendedAjaxAdapter,AjaxAdapter);

  //override original query function to support default results
  var originQuery = AjaxAdapter.prototype.query;

  ExtendedAjaxAdapter.prototype.query = function (params, callback) {
    let defaultResults = (typeof this.defaultResults == 'function') ? this.defaultResults.call(this) : this.defaultResults;
    if (defaultResults && defaultResults.length && (!params.term || params.term.length < this.minimumInputLength)) {
      callback(this.processResults({ results: defaultResults }, params))
    } else {
      originQuery.call(this, params, callback)
    }
  }

  if (withTags) {
    return Utils.Decorate(ExtendedAjaxAdapter, Tags)
  } else {
    return ExtendedAjaxAdapter
  }
}

// $('.select2-selection__choice__remove').click(function() {
//   event.stopPropagation();
// });
